import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import FlightWithConnectionLine from '../flightWithConnectionLine/FlightWithConnectionLine';

import './FlightGrid.css';

const I18n = require('i18n-react').default;

const propTypes = {
  isDeparture: PropTypes.bool,
  id: PropTypes.string.isRequired,
  flights: PropTypes.arrayOf(
    PropTypes.shape({
      originAirport: PropTypes.string.isRequired,
      originAirportName: PropTypes.string.isRequired,
      finalDestination: PropTypes.string.isRequired,
      finalDestinationName: PropTypes.string.isRequired,
      departureDate: PropTypes.string,
      departureTime: PropTypes.string.isRequired,
      finalArrivalDate: PropTypes.string,
      finalArrivalTime: PropTypes.string.isRequired,
      dateVariation: PropTypes.number.isRequired,
      elapsedFlightTime: PropTypes.string,
      firstFlightNumber: PropTypes.number.isRequired,
      operatingCarriers: PropTypes.array.isRequired,
      prices: PropTypes.arrayOf(
        PropTypes.shape({
          category: PropTypes.string.isRequired,
          passenger: PropTypes.string,
          value: PropTypes.number,
          currency: PropTypes.string
        })
      ),
      baggage: PropTypes.arrayOf(
        PropTypes.shape({
          category: PropTypes.string.isRequired,
          quantity: PropTypes.number,
          weight: PropTypes.number
        })
      ),
      connection: PropTypes.number.isRequired,
      hasExchangeAirport: PropTypes.bool.isRequired,
      throughFlight: PropTypes.number.isRequired,
      returnFlights: PropTypes.arrayOf(PropTypes.object),
      flightGroup: PropTypes.arrayOf(PropTypes.object)
    })
  ).isRequired,
  filterDepartureDate: PropTypes.string.isRequired,
  filterReturnDate: PropTypes.string,
  callback: PropTypes.func,
  callbackAlterSearch: PropTypes.func,
  manyDepartureFlightOptions: PropTypes.bool,
  toogleElapsedFlightTime: PropTypes.bool,
  toggleDetailsModal: PropTypes.bool,
  filterCabinCategory: PropTypes.string.isRequired,
  featureShowModalSelectionFlightsToggle: PropTypes.bool,
  isCallcenterEnabled: PropTypes.bool
};

const defaultProps = {
  flights: [],
  toogleElapsedFlightTime: false,
  toggleDetailsModal: false,
  isDeparture: true,
  featureFlightsGridCabinTypeToggle: false,
  featureShowModalSelectionFlightsToggle: false 
};

class FlightGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      featureShowModalSelectionFlightsToggle: props.featureShowModalSelectionFlightsToggle
    };
  }

  componentWillReceiveProps(nextProps) {
    let featureShowModalSelectionFlightsToggle = nextProps.featureShowModalSelectionFlightsToggle;
    if (
      featureShowModalSelectionFlightsToggle !== this.props.featureShowModalSelectionFlightsToggle
    ) {
      this.setState({
        featureShowModalSelectionFlightsToggle: featureShowModalSelectionFlightsToggle
      });
    }
  }

  obtainDepartureFlight(flight) {
    return {
      time: flight.departureTime,
      plusDays: null,
      airportSign: flight.originAirport,
      airportName: flight.originAirportName
    };
  }

  obtainArrivalFlight(flight) {
    return {
      time: flight.finalArrivalTime,
      plusDays: flight.dateVariation,
      airportSign: flight.finalDestination,
      airportName: flight.finalDestinationName
    };
  }

  setChoosenFlight(category, points, flight, rangePointsPlusMoney) {    
    this.props.callback({
      value: rangePointsPlusMoney ? rangePointsPlusMoney.points : points,
      category: category,
      flight,
      rangePointsPlusMoney: rangePointsPlusMoney
    });
  }

  renderHeaderWithPrice() {
    let component = (
      <Col md={5} xsHidden className="vertical-middle-col">
        <Row>
          <Col md={6} className="text-center">
            <Row>
              <Col id="lblEconomy" md={12}>
                <span>{I18n.translate('components.flightGrid.economy')}</span>
              </Col>
            </Row>
          </Col>
          <Col md={6} className="text-center">
            <Row>
              <Col id="lblBusiness" md={12}>
                <span>{I18n.translate('components.flightGrid.business')}</span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    );

    const isEconomy = this.props.filterCabinCategory == 'ECONOMY';
    component = (
      <Col md={3} xsHidden className="vertical-middle-col">
        <Row>
          <Col md={12} className="text-center">
            <Row>
              <Col id={`lbl${isEconomy ? 'Economy' : 'Business'}`} md={12}>
                <span>
                  {I18n.translate(
                    `components.flightGrid.${
                      isEconomy ? 'economyInformative' : 'businessInformative'
                    }`
                  )}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    );

    return component;
  }

  renderHeaderWithLogo() {
    return (
      <Row className="flightGrid header-with-logo vertical-middle-row">
        <Col
          id="lblCompany"
          md={3}
          xsHidden
          className="vertical-middle-col">
          <span>{I18n.translate('components.flightGrid.company')}</span>
        </Col>
        <Col
          id="lblFlightDetails"
          md={6}
          xsHidden
          className="text-center vertical-middle-col">
          <span>{I18n.translate('components.flightGrid.flightDetails')}</span>
        </Col>
        {this.renderHeaderWithPrice()}
      </Row>
    );
  }

  getKey(flight) {
    return `flight-item-${flight.id}-${flight.fareOriginType}-${this.props.filterDepartureDate}${
      this.props.filterReturnDate ? `-${this.props.filterReturnDate}` : ''
    }`;
  }

  renderFlights() {
    let list = [];
    if (this.props.flights.length > 0) {
      list = this.props.flights.map(flight => {
        return (
          <FlightWithConnectionLine
            key={this.getKey(flight)}
            id={this.getKey(flight)}
            isDeparture={this.props.isDeparture}
            flightNumber={flight.firstFlightNumber}
            operatingCarriers={flight.operatingCarriers}
            connections={flight.connection}
            throughFlights={flight.throughFlight}
            hasExchangeAirport={flight.hasExchangeAirport}
            price={flight.prices}
            baggage={flight.baggageReturn? flight.baggageReturn : flight.baggage}
            fareDeparture={flight.recommendations !== null ? flight.recommendations[0].fare !== null ? flight.recommendations[0].fare : flight.recommendations[0].returnFlights[0].categories[0].fare.departure : flight.fare[flight.prices[0].category.toLowerCase()].return}
            elapsedFlightTime={flight.elapsedFlightTime}
            toogleElapsedFlightTime={this.props.toogleElapsedFlightTime}
            toggleDetailsModal={this.props.toggleDetailsModal}
            departureFlight={this.obtainDepartureFlight(flight)}
            departureDate={flight.departureDate}
            arrivalFlight={this.obtainArrivalFlight(flight)}
            flightGroup={flight.flightGroup}
            callbackAlterSearch={this.props.callbackAlterSearch}
            callbackSelectEconomy={(price,rangePointsPlusMoney) => {              
              this.setChoosenFlight('economy', price, flight,rangePointsPlusMoney);
            }}
            callbackSelectBusiness={(price,rangePointsPlusMoney) => {
              this.setChoosenFlight('business', price, flight,rangePointsPlusMoney);
            }}
            ref={c => (this['flight-line-' + flight.id] = c)}
            featureShowModalSelectionFlightsToggle={
              this.state.featureShowModalSelectionFlightsToggle
            }
            filterCabinCategory={this.props.filterCabinCategory}
            isCallcenterEnabled={this.props.isCallcenterEnabled}
            ranges={flight.ranges}
            flight={flight}
          />
        );
      });
    } else {
      list.push(
        <FlightWithConnectionLine
          key="empty"
          id="empty"
          filterCabinCategory={this.props.filterCabinCategory}
          hasEmpty={true}
          manyDepartureFlightOptions={this.props.manyDepartureFlightOptions}
          callbackAlterSearch={this.props.callbackAlterSearch}
          isCallcenterEnabled={this.state.isCallcenterEnabled}
        />
      );
    }

    return list;
  }

  render() {
    return (
      <div id={`componentFlightGrid-${this.props.id}`} className="flightGrid">
        {this.props.flights.length > 0 ? this.renderHeaderWithLogo() : null}
        {this.renderFlights()}
      </div>
    );
  }
}

FlightGrid.propTypes = propTypes;
FlightGrid.defaultProps = defaultProps;

export default FlightGrid;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightGrid/FlightGrid.jsx